import { ROUTES } from "const";

export class DIGCOMP {

    static getDashboardCards(aa) {
        if (aa < 2025) {
            return [
                {
                    title: 'Bando', link: ROUTES.COURSE_MANIFESTO,
                    img: '/img/icon/graduate.png', className: 'image-box'
                }, {
                    title: 'Messaggi', link: ROUTES.COURSE_TICKETS,
                    img: '/img/icon/message.png', className: 'image-box'
                }, {
                    title: 'Situazione pagamenti', link: ROUTES.COURSE_PAYMENTS,
                    img: '/img/icon/payment.png', className: 'image-box'
                }, {
                    title: 'Fatture', link: ROUTES.COURSE_INVOICES,
                    img: '/img/icon/invoice.png', className: 'image-box'
                },
                {
                    title: 'Prenotazione esami', link: ROUTES.ICDL_EXAM_RESERVATION,
                    img: '/img/icon/7.webp', className: 'image-box'
                }
            ];

        } else {
            return [
                {
                    title: 'Bando', link: ROUTES.COURSE_MANIFESTO,
                    img: '/img/icon/graduate.png', className: 'image-box'
                },
                {
                    title: 'Materiale didattico', link: ROUTES.DIGCOMP_LESSON,
                    img: '/img/icon/lessons.png', className: 'image-box'
                }, {
                    title: 'Messaggi', link: ROUTES.COURSE_TICKETS,
                    img: '/img/icon/message.png', className: 'image-box'
                }, {
                    title: 'Situazione pagamenti', link: ROUTES.COURSE_PAYMENTS,
                    img: '/img/icon/payment.png', className: 'image-box'
                }, {
                    title: 'Prenotazione esami', link: ROUTES.ICDL_EXAM_RESERVATION,
                    img: '/img/icon/7.webp', className: 'image-box'
                }
            ];
        }

    }

    static getDashboardNotices(courseCode) {
        if (courseCode === 'DIGCOMP2_2') {
            return [
                {
                    title: `Info e istruzioni esame`,
                    content: `<a href="https://www.formazionedocenti.it/files/corsi/DIGCOM/Info_e_istruzioni_esame_DigComp_2_2.pdf" target="_blank">Clicca qui per scaricare il file</a>`,
                },
                {
                    title: `Syllabus DIGCOMP2.2`,
                    content: `<a href="https://www.formazionedocenti.it/files/corsi/DIGCOM/syllabus_esame_digcomp_2_2.pdf" target="_blank">Clicca qui per scaricare il file</a>`,
                },
                {
                    title: `Corso/Manuale di preparazione  per l'esame DIGCOMP2.2`,
                    content: `<a href="https://www.formazionedocenti.it/files/corsi/DIGCOM/Manuale_per_Esame_DigComp_2_2.pdf" target="_blank">Clicca qui per scaricare il file</a>`,
                },
            ];
        } else if (courseCode === 'DIGCOMPEDU') {
            return [
                {
                    title: `Info e istruzioni esame`,
                    content: `<a href="https://www.formazionedocenti.it/files/corsi/DIGCOM/Info_e_istruzioni_esame_DigCompEdu.pdf" target="_blank">Clicca qui per scaricare il file</a>`,
                },
                {
                    title: `Syllabus DIGCOMPEDU`,
                    content: `<a href="https://www.formazionedocenti.it/files/corsi/DIGCOM/Syllabus_DigCompEdu.pdf" target="_blank">Clicca qui per scaricare il file</a>`,
                },
            ];
        } else {

        }
    }
}